<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           :width="700"
           @on-cancel="cancel"
    >
      <h3 slot="header" class="modal-header">修改枚举值配置</h3>
      <section style="padding-bottom: 60px">
        <Form :label-width=100  class="mb16">

          <FormItem class="notip ivu-form-item-required" label="元数据名称"
                    label-position="left"
                    style="align-items: center">
            <Select size="small"  style="width: 120px;" v-model="enumKey"  disabled>
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in metaList" :value="item.enumKey" :key="'keyA'+index">{{item.enumName}}
              </Option>

            </Select>
            <Button style="margin-left: 20px" type="primary" size="small" @click.stop="add">添加</Button>
          </FormItem>
        </Form>


        <div v-if="chooseType===2" class="notip">
          <!--          :rules="singleRule"-->

          <Form :label-width=60 v-for="(item,index) in list" style="width: 100%;"
                inline :key="'keyV'+index"
                :rules="ruleRange"
                :ref="'form'+index"
                :model="item"
          >
            <FormItem :label="metaListMap[enumKey + ''].title" class="notip"
                      v-if="metaListMap[enumKey + ''].title"
                      prop="key">
              <Select size="small" class="formwidth" v-model="item.key">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in metaListMap[enumKey+''].extList" :value="item.value"
                        :key="'keyB'+index">{{item.key}}
                </Option>
              </Select>
            </FormItem>

            <FormItem label="最小值" class="notip" prop="begin">
              <InputNumber  :min="-100" :max="101"  v-model="item.begin" size="small" class="inputwidth"></InputNumber>
            </FormItem>
            <FormItem label="最大值" class="notip" prop="end">
              <InputNumber :min="-100" :max="101" v-model="item.end" size="small"></InputNumber>
            </FormItem>
            <FormItem label="系数" class="notip" prop="value">
              <InputNumber v-model="item.value" size="small" :max="10" :min="0"></InputNumber>
<!--              <Button size="small" style="margin-left: 10px" @click.stop="deleteItem(index)">删除</Button>-->

            </FormItem>
            <FormItem label="备注" class="notip" >
              <Input v-model="item.title" size="small" class="inputwidth"></Input>
              <Button size="small" style="margin-left: 30px" @click.stop="deleteItem(index)" v-if="index!==0">删除</Button>
            </FormItem>

          </Form>

        </div>
        <div v-if="chooseType===1">

          <Form :label-width=60 v-for="(item,index) in list"
                inline :key="'keyB'+index"
                :rules="ruleSingle"
                :ref="'form'+index"
                :model="item"
          >
            <FormItem :label="metaListMap[enumKey + ''].title" class="notip"
                      v-if="metaListMap[enumKey + ''].title"
                      prop="key">
              <Select size="small" class="formwidth" v-model="item.key">
                <Option v-for="(item1,index1) in metaListMap[enumKey+''].extList"
                        :value="item1.value"
                        :key="'keyB'+index1">{{item1.text}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="系数" class="notip" prop="value">
              <InputNumber size="small" v-model="item.value" :min="0" :max="10"></InputNumber>
              <Button size="small" style="margin-left: 30px" @click.stop="deleteItem(index)" v-if="index!==0">删除</Button>

            </FormItem>
          </Form>

        </div>
      </section>
    </Modal>
  </div>


</template>
<script>
  import {saveMeta,updateMeta} from "../../../../../api/meta";
  import {deepClone} from "../../../../../utils/format";

  export default {
    name: "",
    props: {
      n: {
        type: Number,
        default: 0
      },
      metaList: {
        type: Array,
        defalut: () => {
          return []
        }
      },
      item:{
        type:Object,
        defalut: null
      }
    },
    computed: {

      metaListMap() {
        let ret = {}
        this.metaList.forEach(item => {
          ret[item.enumKey + ''] = item
        })
        return ret
      },
      chooseType() {
        if (!this.enumKey || !this.metaListMap[this.enumKey + '']) {
          return null

        }
        return this.metaListMap[this.enumKey + ''].enumType


      },
      itemData() {
        if (!(this.enumKey + '')) {
          return null
        }
        // 枚举类型 0-非枚举，1-单值，2-范围值
        if (this.chooseType === 1) {
          return {
            title: '',
            key: null,
            value: null
          }
        }

        if (this.chooseType === 2) {
          return {
            title: '',
            key: null,
            value: null,
            begin: null,
            end: null
          }
        }
        return null
      },
    },
    watch: {
      n() {
        this.enumKey=''
        this.list=[]

        if(this.item){
          this.enumKey=this.item.enumKey
          let enumValue=JSON.parse(this.item.enumValue)
          console.log(enumValue)
          enumValue.forEach(ele=>{
            if (this.chooseType === 1) {
              this.list.push({
                title: '',
                key: ele.key?ele.key:'',
                value: ele.value
              })
            }

            if (this.chooseType === 2) {
              this.list.push({
                title: ele.title,
                key: ele.key?ele.key:'',
                value: ele.value,
                begin: ele.begin,
                end: ele.end
              })
            }

          })
        }

        this.$nextTick(()=>{
          this.isShow = true
        })

      },

    },
    data() {
      return {
        loading: true,
        isShow: false,
        singleRule: {},
        enumKey: '',
        list: [],
        ruleRange: {
          key: [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          value: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],
          begin: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],
          end: [{required: true, message: ' ', trigger: 'blur', type: 'number'}]

        },
        ruleSingle: {
          key: [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          value: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],
        },

      }
    },
    methods: {
      deleteItem(index) {
        this.list.splice(index, 1)
      },
      saveMeta(){
        if(this.chooseType===1){
        if(this.metaListMap[this.enumKey+'']&&this.metaListMap[this.enumKey+''].title){
          let map={}
          this.metaListMap[this.enumKey+''].extList.forEach(ele=>{
            map[ele.value+'']=ele.text
          })
          this.list.forEach(ele=>{
            ele['title']=map[ele.key+'']
          })
        }
        }


        let params={
          orgMetaRelFid:this.metaListMap[this.enumKey+''].orgMetaRelFid,
          enumKey:this.enumKey,
          enumValueList:this.list,
          enumType:this.chooseType,
          metaEnumFid:this.item.metaEnumFid
        }
        updateMeta(params).then(res=>{
          this.$Message.success('修改成功')
          this.$emit('done')
        }).catch(error=>{
          // this.$Message.info('保存失败')
        }).finally(()=>{
          this.isShow=false
        })

      },
      add() {
        if (!(this.enumKey + '')) {
          this.$Message.info('请先选择元数据')
          return
        }
        this.list.push(deepClone(this.itemData))
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (!this.list.length) {
          this.isShow = false
          return
        }
        let validate = true
        for (let i in this.$refs) {
          this.$refs[i].forEach(item => {
            item.validate(bool => {
              !bool && (validate = bool)
            })
          })
        }
        if (!validate) {
          this.changeLoading()
          return
        }

        this.saveMeta()
      },
      cancel() {
      }
    }

  }
</script>

<style scoped>
  .formwidth {
    width: 100px;
    display: inline-block;
  }

  .inputwidth {
    width: 80px;
  }

</style>
